<template lang="pug">
  .active-month-form.pb-3
    .table-view-header
      .table-view-header-title
        h3 Meses activo
    b-container(fluid)
      b-form
        b-row(align-h="start" align-content="start")
          b-col(cols="12")
            b-form-checkbox(v-model="form.jan" switch) Enero
          b-col(cols="12")
            b-form-checkbox(v-model="form.feb" switch) Febrero
          b-col(cols="12")
            b-form-checkbox(v-model="form.mar" switch) Marzo
          b-col(cols="12")
            b-form-checkbox(v-model="form.apr" switch) Abril
          b-col(cols="12")
            b-form-checkbox(v-model="form.may" switch) Mayo
          b-col(cols="12")
            b-form-checkbox(v-model="form.jun" switch) Junio
          b-col(cols="12")
            b-form-checkbox(v-model="form.jul" switch) Julio
          b-col(cols="12")
            b-form-checkbox(v-model="form.aug" switch) Agosto
          b-col(cols="12")
            b-form-checkbox(v-model="form.sep" switch) Septiembre
          b-col(cols="12")
            b-form-checkbox(v-model="form.oct" switch) Octubre
          b-col(cols="12")
            b-form-checkbox(v-model="form.nov" switch) Noviembre
          b-col(cols="12")
            b-form-checkbox(v-model="form.dec" switch) Diciembre
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      form: {
        serviceId: null,
        jan: true,
        feb: true,
        mar: true,
        apr: true,
        may: true,
        jun: true,
        jul: true,
        aug: true,
        sep: true,
        oct: true,
        nov: true,
        dec: true
      }
    }
  },
  watch: {
    form: {
      handler(){
        this.updateServiceMonthsActive(this.form)
      },
      deep: true
    },
    service () {
      this.form = this.service.monthsActive
    }
  },
  methods: {
    ...mapActions(['updateServiceMonthsActive'])
  },
  computed: {
    ...mapGetters(['service'])
  },
  created () {
    this.form = this.service.monthsActive
  }
}
</script>